<template>
  <v-expansion-panels
    multiple
    accordion
    tile
    :value="[0, 1, 2, 3]"
    class="style-container"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>Thông tin</v-expansion-panel-header>
      <v-expansion-panel-content>
        <field-group
          label="Trường"
          class="my-1"
          v-model="item.field"
          typeInput="v-select"
          :items="fields"
          item-text="name"
          item-value="code"
        ></field-group>
        <field-group
          label="Min zoom"
          class="my-1"
          type="number"
          :min="0"
          :max="24"
          v-model="item.minzoom"
        ></field-group>
        <field-group
          label="Max zoom"
          class="my-1"
          type="number"
          :min="0"
          :max="24"
          v-model="item.maxzoom"
        ></field-group>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>Bộ lọc</v-expansion-panel-header>
      <v-expansion-panel-content>
        <edit-filter
          class="pt-2"
          v-model="item.rules"
          :fields="fields"
        ></edit-filter>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>Trình bày</v-expansion-panel-header>
      <v-expansion-panel-content>
        <edit-style
          class="pt-2"
          v-model="item.style"
          :typeLayer.sync="typeLayer"
          :fields="fields"
        ></edit-style>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { DEFAULT_VALUE_STYLE } from './constant'
import editFilter from './tab/edit-tab-filter.vue'
import editStyle from './tab/edit-label-tab-style.vue'
export default {
  components: { editStyle, editFilter },
  props: {
    typeLayer: { type: String, default: 'Point' },
    item: { type: Object, default: () => ({}) },
    fields: { type: Array },
  },
  data: () => ({}),
  watch: {},
  methods: {
    changeTypeLayer(e) {
      this.item.style = DEFAULT_VALUE_STYLE[e] || {}
      this.$emit('update:typeLayer', e)
    },
  },
}
</script>

<style scope lang="scss">
.style-container {
  .v-expansion-panel-header {
    min-height: 30px;
    cursor: pointer;
    user-select: none;
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
  }
  .v-expansion-panel-header--active {
    border-bottom: solid 1px var(--v-secondary-lighten5);
  }
  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 30px;
  }
  .v-expansion-panel-header__icon .v-icon.v-icon {
    font-size: 14px;
  }
  .v-expansion-panels {
    display: block;
  }
}
</style>
